import { render } from "./ViewPageFooter.vue?vue&type=template&id=19929107&scoped=true"
import script from "./ViewPageFooter.vue?vue&type=script&lang=js"
export * from "./ViewPageFooter.vue?vue&type=script&lang=js"

import "./ViewPageFooter.vue?vue&type=style&index=0&id=19929107&scoped=true&lang=css"

import exportComponent from "D:\\workfile\\flycat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19929107"]])

export default __exports__